import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { RouteTitleService } from 'src/app/shared/route-title.service';
import { CpuIdleObserverService } from 'src/lib/amg-monitoring/cpu-idle-observer.service';
import { ActiveAlertObserverService } from 'src/lib/tcs-active-alert/active-alert-observer.service';
import { UserDataContextService } from 'src/lib/tcs-identity/user-data-context.service';
import { PollingService } from 'src/lib/tcs-polling-service/polling.service';
import { PositionReportAlertAudibleService } from '../ops/ops-lib/position-report-alerts/position-report-alert-audible.service';
import { ApolloInitializerService } from './apollo-initializer.service';
import { PageViewService } from './pageview.service';
import { RouterLoadingService } from './router-loading.service';

export function bootstrapApp(appBootstrapper: AppBootstrapService) {
  return (componentRef: ComponentRef<any>) => {
    if (componentRef.instance instanceof AppComponent) {
      const ref = componentRef.injector.get(ViewContainerRef);
      appBootstrapper.init(ref);
    }
  };
}

@Injectable({ providedIn: 'root' })
export class AppBootstrapService {
  constructor(
    private _apollo: ApolloInitializerService,
    private _pageView: PageViewService,
    private _routerLoading: RouterLoadingService,
    private _routeTitle: RouteTitleService,
    private _userData: UserDataContextService,
    private _router: Router,
    private _cpuIdleObserver: CpuIdleObserverService,
    private _polling: PollingService,
    private _activeAlertObserver: ActiveAlertObserverService,
    private _positionReportAlertAudibleService: PositionReportAlertAudibleService,
  ) {}

  public async init(ref: ViewContainerRef): Promise<any> {
    this._apollo.init();
    this._pageView.init();
    this._routerLoading.init(ref);
    this._routeTitle.setTitleOnNavigation();
    this._userData.init();
    this._cpuIdleObserver.init();
    this._polling.init();
    this._positionReportAlertAudibleService.init();
  }
}
